/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnerscolumnbusinesses2Inputs */

const en_partnerscolumnbusinesses2 = /** @type {(inputs: Partnerscolumnbusinesses2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Businesses`)
};

const de_partnerscolumnbusinesses2 = /** @type {(inputs: Partnerscolumnbusinesses2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betriebe`)
};

/**
* | output |
* | --- |
* | "Businesses" |
*
* @param {Partnerscolumnbusinesses2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnerscolumnbusinesses2 = /** @type {((inputs?: Partnerscolumnbusinesses2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnerscolumnbusinesses2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnerscolumnbusinesses2(inputs)
	return de_partnerscolumnbusinesses2(inputs)
});
export { partnerscolumnbusinesses2 as "partnersColumnBusinesses" }